export default __webpack_public_path__ + "static/media/cpic4.c538aac2.jpg";